import { render, staticRenderFns } from "./forum_details.vue?vue&type=template&id=8ca662d8&scoped=true&"
import script from "./forum_details.vue?vue&type=script&lang=js&"
export * from "./forum_details.vue?vue&type=script&lang=js&"
import style0 from "./forum_details.vue?vue&type=style&index=0&id=8ca662d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca662d8",
  null
  
)

export default component.exports